// In-app chat (inbox) API calls — same endpoints and params as the Android technician app
// (api/v3/pro/inbox/*, api/v3/pro/firestore/token). Every call resolves to { ok, body, paging, message }, never throws.
import { apiCall } from "./apiCall";

export const inboxApi = {
  // Firebase custom token for signInWithCustomToken → body { firebase_auth }
  firestoreToken: () => apiCall("post", "firestore/token", {}, { silent: true }),
  // open (or create) the chat room for a booking or an order → body InboxResource
  init: ({ bookingId, orderId }) => apiCall("post", "inbox/init", bookingId ? { booking_id: bookingId } : { order_id: orderId }),
  // store the last message on the inbox row (Android does it when the chat screen pauses)
  update: (inboxId, message) => apiCall("post", "inbox/update", { inbox_id: inboxId, message }, { silent: true }),
  // inbox listing → body InboxResource[] + paging.total_pages
  list: (page = 1, limit = 10) => apiCall("post", "inbox/list", { limit, page }),
};
